import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DetailTitle = _resolveComponent("DetailTitle")!
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock("div", {
    class: "home-analysis-table home-view-box",
    style: _normalizeStyle({ width: _ctx.width + 'px' })
  }, [
    _createVNode(_component_DetailTitle, { title: _ctx.title }, null, 8, ["title"]),
    _createVNode(_component_a_table, {
      dataSource: _ctx.list,
      columns: _ctx.columns.map(item => { if (!item.align) { item.align = 'center' } return item }),
      bordered: "",
      pagination: false,
      scroll: { x: _ctx.width - 34 }
    }, null, 8, ["dataSource", "columns", "scroll"])
  ], 4))
}